module.exports = __webpack_public_path__ + "img/hunt_convert.e59dd538.png";